<template lang="html">
  <span>
  <span class="reportLabel">Indicator {{ indicator.number }}: {{indicator.text}}</span>
  <span v-html="indicator.comments"></span>
</span>
</template>

<script>
export default {
  props: ['indicator', 'oigCase'],
}
</script>

<style lang="css" scoped>
.reportLabel {
  font-size: 0.7rem;
}
</style>
